import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { pricingDetailsAtom } from '../jotai/storefront/pricing';
import { months } from '../routes/fetch/storefrontPage/utils/venuePricing/monthFormat';

const getMonthRange = (startMonth: string, endMonth: string) => {
	const startIndex = months.indexOf(startMonth);
	const endIndex = months.indexOf(endMonth);
	if (startIndex === -1 || endIndex === -1) return [];

	if (startIndex > endIndex)
		return [...months.slice(startIndex), ...months.slice(0, endIndex + 1)];

	return months.slice(startIndex, endIndex + 1);
};

const parseMonths = (input: string | null | undefined): string[] => {
	if (!input) return [];

	const groups = input.split(' and ');

	return groups.flatMap((group) => {
		if (group.includes(',')) {
			return group.split(', ').flatMap((month) => {
				if (month.includes('-')) {
					const [startMonth, endMonth] = month.split('-');
					return getMonthRange(startMonth, endMonth);
				}
				return month;
			});
		}

		if (group.includes('-')) {
			const [startMonth, endMonth] = group.split('-');
			return getMonthRange(startMonth, endMonth);
		}

		return group;
	});
};

export const usePricingSeasonal = () => {
	const { peakMonths, offPeakMonths } = useAtomValue(pricingDetailsAtom);

	return useMemo(
		() => ({
			peakMonths: parseMonths(peakMonths),
			offPeakMonths: parseMonths(offPeakMonths),
		}),
		[peakMonths, offPeakMonths],
	);
};
